module.exports = __webpack_public_path__ + "static/img/feature_3.87c3b7c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hrdonates/feature_3.svg
// module id = /0EX
// module chunks = 0